module.exports = __webpack_public_path__ + "media/futureisnow.5c935b7a.mp4";